export default {
  title: 'Estimator24 — Service zur Immobilienbewertung',
  description: 'Präzise Preisanalyse, KI-Bewertung und Prognose der Marktdynamik',
  login: 'Zum persönlichen Konto einloggen'
}
